function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "26",
  height: "26",
  viewBox: "0 0 26 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: "13",
  cy: "13",
  r: "13",
  fill: "#01C38F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.107 17.24L13.9 13.035l-1.082 1.082 4.208 4.206h-3.264l1.559 1.558h4.344v-4.344l-1.558-1.558v3.263z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.558 8.64l4.207 4.205 1.082-1.08L8.64 7.557h3.263L10.344 6H6v4.344l1.558 1.558V8.639z",
  fill: "#fff"
})));